export default {
    DRAFT: 100,
    PUBLISHED_TO_SANDBOX: 200,
    SUSPENDED: 300,
}
